var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var WcMen = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13,9 C14.1045695,9 15,9.8954305 15,11 L15,16 L14,16 L14,21 L9,21 L9,16 L8,16 L8,11 C8,9.8954305 8.8954305,9 10,9 L13,9 Z M13,10 L10,10 C9.48716416,10 9.06449284,10.3860402 9.00672773,10.8833789 L9,11 L9,15 L10,15 L10,20 L13,20 L13,15 L14,15 L14,11 C14,10.4871642 13.6139598,10.0644928 13.1166211,10.0067277 L13,10 Z M11.5,4 C12.8807119,4 14,5.11928813 14,6.5 C14,7.88071187 12.8807119,9 11.5,9 C10.1192881,9 9,7.88071187 9,6.5 C9,5.11928813 10.1192881,4 11.5,4 Z M11.5,5 C10.6715729,5 10,5.67157288 10,6.5 C10,7.32842712 10.6715729,8 11.5,8 C12.3284271,8 13,7.32842712 13,6.5 C13,5.67157288 12.3284271,5 11.5,5 Z" })));
};
WcMen.displayName = 'WcMen';
export default WcMen;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WcMen.js.map